module.exports = __webpack_public_path__ + "img/close_blue.70c0ae4f.svg";